import { CompositionEffect, DURATION_VERY_LONG } from './CompositionEffect';

const { Power2 } = window as any;

class Composition extends CompositionEffect {
  static id = 'composition-fade';
  static label = 'Fade';

  protected compose(position: number) {
    const p = Power2.easeOut(position);
    this.layer.sprite.alpha = p;
  }
  protected decompose(position: number) {
    const p = Power2.easeIn(position);
    this.layer.sprite.alpha = 1 - p;
  }

  getInitialDuration(): string {
    return DURATION_VERY_LONG;
  }
}

(window as any).BeatFlyer.compositions[Composition.id] = Composition;



// WEBPACK FOOTER //
// ./src/compose/ComposeFade.ts